import React from 'react';
import { RefreshCcw, Home, AlertTriangle } from 'lucide-react';
import Button from './Buttons/Button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Log error to console and potentially to monitoring service
    console.error('Error Boundary caught an error:', error, errorInfo);
    
    // You can integrate with error reporting services like Sentry here
    // if (window.Sentry) {
    //   window.Sentry.captureException(error, {
    //     contexts: {
    //       react: {
    //         componentStack: errorInfo.componentStack
    //       }
    //     }
    //   });
    // }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    // Navigate to home page
    window.location.href = process.env.PUBLIC_URL || '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '20px',
          textAlign: 'center',
          backgroundColor: '#f8f9fa',
          fontFamily: 'Lato, sans-serif'
        }}>
          <div style={{
            maxWidth: '600px',
            width: '100%',
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '40px',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
            border: '1px solid #dee2e6'
          }}>
            <AlertTriangle size={64} color="#D84949" style={{ marginBottom: '24px' }} />
            
            <h1 style={{ 
              fontSize: '28px', 
              marginBottom: '16px', 
              color: '#0C0E29',
              fontWeight: '600',
              fontFamily: 'Lato, sans-serif',
              margin: '0 0 16px 0'
            }}>
              Something went wrong
            </h1>
            
            <p style={{ 
              fontSize: '16px', 
              marginBottom: '32px', 
              color: '#6c757d',
              maxWidth: '500px',
              lineHeight: '1.6',
              fontFamily: 'Lato, sans-serif',
              margin: '0 auto 32px auto'
            }}>
              We're sorry, but something unexpected happened while using Taplr. 
              Please try refreshing the page or return to the homepage to continue.
            </p>
            
            <div style={{ 
              display: 'flex', 
              gap: '16px', 
              justifyContent: 'center',
              marginBottom: '32px',
              flexWrap: 'wrap'
            }}>
              <Button 
                variant="primary"
                onClick={this.handleReload}
                startIcon={<RefreshCcw />}
              >Try Again</Button>
              
              <Button 
                variant="secondary"
                startIcon={<Home />}
                onClick={this.handleGoHome}
              >Go Home</Button>
            </div>
            
            <div style={{
              padding: '20px',
              backgroundColor: '#f8f9fa',
              borderRadius: '6px',
              fontSize: '14px',
              color: '#495057',
              fontFamily: 'Lato, sans-serif',
              border: '1px solid #dee2e6'
            }}>
              <strong>Need help?</strong> If this problem persists, please contact our support team 
              with details about what you were doing when this error occurred.
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;